import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { AuthShell } from "@/pages/Register";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const user = await login(form.email, form.password);
      toast.success("Connexion réussie");
      navigate(user.role === "admin" ? "/admin" : "/ressources");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Connexion" subtitle="Accédez à votre espace et à toutes les ressources.">
      <form onSubmit={submit} className="space-y-6" data-testid="login-form">
        <div className="space-y-2">
          <Label className="text-xs uppercase tracking-[0.16em] text-[#5E5356]">Email</Label>
          <Input
            data-testid="login-email-input"
            type="email"
            required
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            className="h-12 rounded-xl border-[#E8D7D0] focus-visible:ring-[#B76E79]"
          />
        </div>
        <div className="space-y-2">
          <Label className="text-xs uppercase tracking-[0.16em] text-[#5E5356]">Mot de passe</Label>
          <Input
            data-testid="login-password-input"
            type="password"
            required
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            className="h-12 rounded-xl border-[#E8D7D0] focus-visible:ring-[#B76E79]"
          />
        </div>

        {error && (
          <p data-testid="login-error" className="text-sm text-red-600 bg-red-50 rounded-xl px-4 py-3">
            {error}
          </p>
        )}

        <Button
          type="submit"
          disabled={loading}
          data-testid="login-submit-btn"
          className="w-full h-12 rounded-full bg-[#B76E79] hover:bg-[#A25D67] text-white text-base"
        >
          {loading ? "Connexion…" : "Se connecter"}
        </Button>

        <p className="text-sm text-[#5E5356]">
          <Link
            to="/mot-de-passe-oublie"
            data-testid="login-forgot-link"
            className="text-[#B76E79] hover:underline"
          >
            Mot de passe oublié ?
          </Link>
        </p>

        <p className="text-sm text-[#5E5356]">
          Pas encore de compte ?{" "}
          <Link to="/inscription" data-testid="login-to-register-link" className="text-[#B76E79] hover:underline">
            S'inscrire
          </Link>
        </p>
      </form>
    </AuthShell>
  );
}
